import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const projectApi = createApi({
  reducerPath: "projectApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/is/project",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Project"],
  endpoints: (build) => ({
    getProject: build.query({
      query: (id) => `${id}`,
      providesTags: ["Project"],
    }),
    getProjects: build.query({
      query: () => "",
      providesTags: ["Project"],
    }),
    getProjectDocs: build.query({
      query: (id) => `/${id}/document`,
      providesTags: ["Project"],
    }),
    getProjectEntitlements: build.query({
      query: (params) => {
        return {
          url: "/myentitlements",
          params: params,
        };
      },
      providesTags: ["Project"],
    }),
    getProjectCertificates: build.query({
      query: (params) => {
        return {
          url: "/certificatedetails",
          params: params,
        };
      },
      providesTags: ["Project"],
    }),
    addProject: build.mutation({
      query(body) {
        return {
          url: ``,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Project"],
    }),
    addDocumentToProject: build.mutation({
      query(body) {
        return {
          url: `/${body.interventionid}/document`,
          method: "POST",
          body: body.requestbody,
        };
      },
      invalidatesTags: ["Project"],
    }),
    deleteDocumentToProject: build.mutation({
      query({ project_id, document_id }) {
        return {
          url: `/${project_id}/document?document_id=${document_id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Project"],
    }),
    updateProjectDocuments: build.mutation({
      query(body) {
        return {
          url: `/batch/document`,
          method: "PUT",
          body: body,
        };
      },
      invalidatesTags: ["Project"],
    }),
    updateProject: build.mutation({
      query(payload) {
        return {
          url: `${payload.id}`,
          method: "PUT",
          body: payload.body,
        };
      },
      invalidatesTags: ["Project"],
    }),
    updateProjectStatus: build.mutation({
      query(payload) {
        return {
          url: `/${payload.id}/status`,
          method: "PUT",
          body: payload.body,
        };
      },
      invalidatesTags: ["Project"],
    }),
    deleteProject: build.mutation({
      query(id) {
        return {
          url: `${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Project"],
    }),
  }),
});

export const {
  useGetProjectDocsQuery,
  useDeleteDocumentToProjectMutation,
  useGetProjectEntitlementsQuery,
  useGetProjectCertificatesQuery,
  useAddDocumentToProjectMutation,
  useUpdateProjectDocumentsMutation,
  useGetProjectQuery,
  useGetProjectsQuery,
  useAddProjectMutation,
  useUpdateProjectMutation,
  useUpdateProjectStatusMutation,
  useDeleteProjectMutation,
} = projectApi;
